import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, getFormValues } from 'redux-form';

import Content from '../../common/template/content';
import ContentCard from '../../common/template/contentCard';
import ContentCardHeader from '../../common/template/contentCardHeader';
import ContentCardBody from '../../common/template/contentCardBody';
import ContentCardFooter from '../../common/template/contentCardFooter';
import Row from '../../common/layout/row';
import Grid from '../../common/layout/grid';
import Button from '../../common/button/button';
import Form from '../../common/form/form';
import LabelAndInput from '../../common/form/labelAndInput';
import LabelAndInputNumber from '../../common/form/labelAndInputNumber';
import LabelAndInputMask from '../../common/form/labelAndInputMask';
import LabelAndInputDateTime from '../../common/form/labelAndInputDateTime';
import Select from '../../common/form/select';
import SelectAlteracao from '../../common/form/selectAlteracao';
import LabelAndCheckbox from '../../common/form/labelAndCheckbox';
import LabelAndInputDate from '../../common/form/labelAndInputDate';

import {
	setModoTela, initForm
} from './checklistPerguntasActions';

class ChecklistPerguntasForm extends Component {

	state = {

	}

	componentWillMount() {

	}

	render() {

		let readOnly = this.props.excluir ? 'readOnly' : '';



		return (
			<ContentCard>
				<Form event={this.props.handleSubmit}>
					<ContentCardBody>
						<Row>
                            <Field
								name='descricao'
								component={LabelAndInput}
								label='Descrição' placeholder='Informe a descrição'
								cols='12 12 12 12'
								readOnly={readOnly} />

							<Field
								name='escolha'
								component={LabelAndCheckbox}
								label='Escolha' placeholder='Seleciona se está em conformidade'
								cols='12 12 12 12'
								readOnly={readOnly} />

							<Field
								name='texto'
								component={LabelAndCheckbox}
								label='Observação' placeholder='Solicita texto explicativo'
								cols='12 12 12 12'
								readOnly={readOnly} />

							{!this.props.formularioValues.escolha &&
							<Field
								name='foto'
								component={LabelAndCheckbox}
								label='Foto' placeholder='Solicita foto'
								cols='12 12 12 12'
								readOnly={readOnly} />}

							{this.props.formularioValues.escolha &&
							<Field
								name='obriga_foto_sim'
								component={LabelAndCheckbox}
								label={`Obriga caso "Conforme"`} placeholder='Solicita foto'
								cols='12 12 12 12'
								readOnly={readOnly} />}
							
							{this.props.formularioValues.escolha &&
							<Field
								name='obriga_foto_nao'
								component={LabelAndCheckbox}
								label={`Obriga caso "Não Conforme"`} placeholder='Solicita foto'
								cols='12 12 12 12'
								readOnly={readOnly} />}

							<Field
								name='gera_ocorrencia'
								component={LabelAndCheckbox}
								label='Gera Ocorrência' placeholder='Gera Ocorrência Padrão'
								cols='12 12 12 12'
								readOnly={readOnly} />

							{/*this.props.formularioValues.id_tipo == 1 && //Carregamento
							<Field
								name='apenas_primeira_coleta'
								component={LabelAndCheckbox}
								label='Solicita apenas na primeira coleta' placeholder='Solicita'
								cols='12 12 12 12'
								readOnly={readOnly} />}

							{this.props.formularioValues.id_tipo == 2 && //Descarga
							<Field
								name='apenas_ultima_entrega'
								component={LabelAndCheckbox}
								label='Solicita apenas na última entrega' placeholder='Solicita'
								cols='12 12 12 12'
								readOnly={readOnly} />*/}

							<Field
								name='id_setor'
								component={Select}
								label='Setor' placeholder='Selecione o setor'
								cols='12 12 12 12'
								readOnly={readOnly}
								options={this.props.listaSetor} />

						</Row>

					</ContentCardBody>
					<ContentCardFooter>
						<Row alignCenter>
							<Grid cols='6 6 4 3'>
								{this.props.excluir ? (
									<Button
										text='Excluir'
										submit type={'danger'}
										icon={'fa fa-trash'} />
								) : (
									<Button
										text='Salvar'
										submit
										type={'success'}
										icon={'fa fa-check'} />
								)}
							</Grid>
							<Grid cols='6 6 4 3'>
								<Button
									text='Voltar'
									type={'warning'}
									icon={'fa fa-chevron-left'}
									event={() => this.props.setModoTela('lista')} />
							</Grid>
						</Row>
					</ContentCardFooter>
				</Form>
			</ContentCard>
		)
	}


}

ChecklistPerguntasForm = reduxForm({ form: 'checklistPerguntasForm', destroyOnUnmount: false })(ChecklistPerguntasForm);
const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	usuarioLogado: state.auth.usuarioLogado,
	formularioValues: getFormValues('checklistPerguntasForm')(state),
	registro: state.checklistPerguntas.registro,
	listaSetor: state.checklistPerguntas.listaSetor
});
const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela, initForm
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(ChecklistPerguntasForm);
